// src/components/AccountDetail.jsx
import React, { useEffect, useState } from 'react';
import api from '../api/api';
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import '../styles/AccountDetail.css';

// IMPORTS PARA GENERAR WORD (se mantiene)
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  AlignmentType,
  TabStopType,
} from 'docx';
import { saveAs } from 'file-saver';

// Normalizador
const normalize = (str) =>
  str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() : '';

const AccountDetail = () => {
  const { clientId } = useParams();
  const [accountData, setAccountData] = useState(null);
  const [clientName, setClientName] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [showAbonoModal, setShowAbonoModal] = useState(false);

  const [abonoForm, setAbonoForm] = useState({
    amount: '',
    paymentDate: '',
    method: '',
    note: '',
  });
  const [showFactModal, setShowFactModal] = useState(false);
  const [factForm, setFactForm] = useState({
    orderId: null,
    fact: '',
  });

  const formatter = new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'CRC',
  });

  useEffect(() => {
    const fetchAccountData = async () => {
      try {
        const res = await api.get(`/api/accountsReceivable/${clientId}`);

        setAccountData(res.data);
      } catch (error) {
        console.error('Error al obtener detalle de la cuenta:', error);
      }
    };
    const fetchClient = async () => {
      try {
        const res = await api.get(`/api/clients/${clientId}`);

        setClientName(res.data.name);
      } catch (error) {
        console.error('Error al obtener datos del cliente:', error);
      }
    };
    fetchAccountData();
    fetchClient();
  }, [clientId]);

  if (!accountData) return <div className="account-detail">Cargando cuenta...</div>;

  const { orders, payments } = accountData;
  const creditOrders = orders.filter((o) => normalize(o.formaPago) === 'credito');
  const totalCreditos = creditOrders.reduce(
    (sum, o) => sum + parseFloat(o.totalPayment),
    0
  );
  const totalPagos = payments.reduce((sum, p) => sum + parseFloat(p.amount), 0);
  const totalPendiente = totalCreditos - totalPagos;

  const openOrderModal = (order) => setSelectedOrder(order);
  const closeOrderModal = () => setSelectedOrder(null);

  const hideOrder = async (id) => {
    try {
      await api.put(`/api/orders/${id}/hide`);
      const res = await api.get(`/api/accountsReceivable/${clientId}`);

      setAccountData(res.data);
    } catch (error) {
      console.error('Error al ocultar el pedido:', error);
      alert('Error al ocultar el pedido');
    }
  };

  const hidePayment = async (id) => {
    try {
      await api.put(`/api/ar-payments/${id}/hide`);
      const res = await api.get(`/api/accountsReceivable/${clientId}`);

      setAccountData(res.data);
    } catch (error) {
      console.error('Error al ocultar el pago:', error);
      alert('Error al ocultar el pago');
    }
  };
  const openFactModal = (order) => {
    setFactForm({
      orderId: order.id,
      fact: order.fact || '',
    });
    setShowFactModal(true);
  };

  const closeFactModal = () => {
    setShowFactModal(false);
    setFactForm({ orderId: null, fact: '' });
  };

  const handleFactInputChange = (e) => {
    // Solo números, máximo 6 dígitos (como dijiste)
    const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 6);
    setFactForm((prev) => ({ ...prev, fact: onlyDigits }));
  };

  const handleSaveFact = async (e) => {
    e.preventDefault();
    if (!factForm.orderId) return;

    try {
      await api.put(`/api/orders/${factForm.orderId}/fact`, { fact: factForm.fact || null });

      alert('Número de factura guardado correctamente');

      // Recargamos la cuenta para ver el cambio al toque
      const res = await api.get(`/api/accountsReceivable/${clientId}`);
      setAccountData(res.data);

      closeFactModal();
    } catch (error) {
      console.error('Error al guardar número de factura:', error);
      alert('Error al guardar número de factura');
    }
  };

  // === IMPRESIÓN IGUAL A ACTIVEORDERS ===
  const handlePrint = () => window.print(); // misma función que en ActiveOrders

  // Reimpresión ticket 80mm (copiado/adaptado de ActiveOrders)
  const handlePrintReceipt = () => {
    if (!selectedOrder) return;
    const order = selectedOrder;

    const popup = window.open('', 'PRINT_RECEIPT', 'height=900,width=350');

    const printedAt = new Date();
    const printedDate = printedAt.toLocaleDateString('es-CR');

    popup.document.write(`
      <html>
        <head>
          <title>Factura ${order.orderNumber}</title>
          <style>
            body { width:302px; margin:0 auto; font-family: Arial, sans-serif; background:#fff; color:#000; font-size:16px; line-height:1.4; }
            .header { text-align:center; padding:10px 0; border-bottom:3px solid #000; }
            .header h1 { margin:0; font-size:24px; letter-spacing:1px; font-weight:bold; text-transform:uppercase; }
            .header p { margin:4px 0; font-size:14px; font-weight:bold; }
            .info-block { padding:8px 0; }
            .info-block .row { display:flex; justify-content:space-between; margin:4px 0; }
            .info-block .label { font-weight:bold; width:45%; font-size:16px; }
            .info-block .value { width:50%; font-size:16px; text-align:right; }
            .separator { border-top:1px dashed #000; margin:8px 0; }
            .detalle { margin:6px 0; }
            .detalle p { font-size:16px; }
            .detalle .label-detalle { font-weight:bold; font-size:16px; }
            .totals { margin-top:8px; }
            .totals .row { display:flex; justify-content:space-between; margin:4px 0; }
            .totals .label { font-weight:bold; font-size:16px; }
            .totals .value { font-weight:bold; font-size:16px; text-align:right; }
            .footer { margin-top:10px; font-size:14px; line-height:1.2; }
            .footer p { margin:2px 0; }
            @media print { body { margin:0; } }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>FLORISTERÍA 2000</h1>
            <p>Floristeria2000, Calle 30, San José, San Bosco</p>
            <p>Correo: floristeria2000@hotmail.com | Tel: 2222-1657</p>
          </div>

          <div class="info-block">
            <div class="row"><span class="label">Factura N°:</span><span class="value">${order.orderNumber}</span></div>
            <div class="row"><span class="label">Fecha:</span><span class="value">${printedDate}</span></div>
            <div class="row"><span class="label">Cliente:</span><span class="value">${order.customer || '---'}</span></div>
          </div>

          <div class="separator"></div>

          <div class="info-block">
            <div class="row"><span class="label">Fuente:</span><span class="value">${order.fuente || '---'}</span></div>
            <div class="row"><span class="label">Ejecutiv@:</span><span class="value">${order.ejecutivo || '---'}</span></div>
            <div class="row"><span class="label">Para:</span><span class="value">${order.para || '---'}</span></div>
            <div class="row"><span class="label">Teléfono:</span><span class="value">${order.telefono || '---'}</span></div>
            <div class="row"><span class="label">Entregar en:</span><span class="value">${order.entregarEn || '---'}</span></div>
          </div>

          <div class="separator"></div>

          <div class="detalle">
            <p class="label-detalle">Detalle del Pedido:</p>
            <p>${order.detalleEntrega || '---'}</p>
          </div>

          <div class="separator"></div>
    `);

    if (order.tarjeta && order.tarjeta.toLowerCase() !== 'no') {
      popup.document.write(`
        <div class="info-block">
          <div class="row"><span class="label">Tarjeta:</span><span class="value">${order.tarjetaDetalle || order.tarjeta}</span></div>
        </div>
        <div class="separator"></div>
      `);
    }

    popup.document.write(`
      <div class="totals">
        <div class="row"><span class="label">Parcial:</span><span class="value">₡${(parseFloat(order.total) || 0).toFixed(2)}</span></div>
      `);

    if (order.transporte && parseFloat(order.transporte) > 0) {
      popup.document.write(`
        <div class="row"><span class="label">Transporte:</span><span class="value">₡${(parseFloat(order.transporte) || 0).toFixed(2)}</span></div>
      `);
    }

    if (order.iva === 'Si') {
      const base = (parseFloat(order.total) || 0) + (parseFloat(order.transporte) || 0);
      const ivaAmt = (base * 0.13).toFixed(2);
      popup.document.write(`
        <div class="row"><span class="label">IVA (13%):</span><span class="value">₡${ivaAmt}</span></div>
      `);
    }

    popup.document.write(`
        <div class="row"><span class="label">TOTAL:</span><span class="value">₡${(parseFloat(order.totalPayment) || 0).toFixed(2)}</span></div>
        <div class="row"><span class="label">Forma de pago:</span><span class="value">${order.formaPago || '---'}</span></div>
      </div>

      <div class="separator"></div>

      <div class="footer">
        <p>Para su factura electrónica, rogamos enviar:</p>
        <p>– Nombre o Razón Social</p>
        <p>– Email, Teléfono, Dirección exacta</p>
        <p>al correo: Floristeria2000@hotmail.com</p>
      </div>
      </body></html>
    `);

    popup.document.close();
    popup.focus();
    popup.print();
    setTimeout(() => popup.close(), 500);
  };

  // DOCX export (igual que antes) + Fecha y Hora
  const tabStops = [
    { type: TabStopType.LEFT, position: 1440 },
    { type: TabStopType.LEFT, position: 2880 },
    { type: TabStopType.LEFT, position: 4320 },
    { type: TabStopType.LEFT, position: 5760 },
  ];

  const handleDownload = async () => {
    const children = [];
    children.push(
      new Paragraph({
        children: [
          new TextRun({
            text: `Detalle de la Cuenta - ${clientName.toUpperCase()}`,
            bold: true,
            size: 48,
            font: 'Calibri',
          }),
        ],
        alignment: AlignmentType.CENTER,
        spacing: { after: 300 },
      })
    );
    children.push(
      new Paragraph({
        children: [new TextRun({ text: 'Pedidos', bold: true, size: 36, font: 'Calibri' })],
        alignment: AlignmentType.CENTER,
        spacing: { after: 200 },
      })
    );

    // ✅ Encabezado: se añade "Fecha y Hora" entre Número de Pedido y Total
    children.push(
      new Paragraph({
        children: [
          new TextRun({ text: 'Número de Pedido', bold: true, size: 24, font: 'Calibri' }),
          new TextRun('\t'),
          new TextRun({ text: 'Fecha y Hora', bold: true, size: 24, font: 'Calibri' }),
          new TextRun('\t'),
          new TextRun({ text: 'Total', bold: true, size: 24, font: 'Calibri' }),
          new TextRun('\t'),
          new TextRun({ text: 'Método de Pago', bold: true, size: 24, font: 'Calibri' }),
        ],
        tabStops,
        spacing: { after: 100 },
      })
    );

    // ✅ Filas: se añade scheduledTime formateado
    creditOrders.forEach((o) => {
      children.push(
        new Paragraph({
          children: [
            new TextRun({ text: o.orderNumber, size: 24, font: 'Calibri' }),
            new TextRun('\t'),
            new TextRun({
              text: `Fecha y Hora: ${
                o.scheduledTime
                  ? moment(o.scheduledTime).tz('America/Costa_Rica').format('DD/MM/YYYY h:mma')
                  : 'N/A'
              }`,
              size: 24,
              font: 'Calibri',
            }),
            new TextRun('\t'),
            new TextRun({ text: formatter.format(o.totalPayment), size: 24, font: 'Calibri' }),
            new TextRun('\t'),
            new TextRun({ text: o.formaPago, size: 24, font: 'Calibri' }),
          ],
          tabStops,
        })
      );
    });

    children.push(new Paragraph({ text: '', spacing: { after: 300 } }));

    children.push(
      new Paragraph({
        children: [new TextRun({ text: 'Pagos', bold: true, size: 36, font: 'Calibri' })],
        alignment: AlignmentType.CENTER,
        spacing: { after: 200 },
      })
    );
    children.push(
      new Paragraph({
        children: [
          new TextRun({ text: 'Monto', bold: true, size: 24, font: 'Calibri' }),
          new TextRun('\t'),
          new TextRun({ text: 'Fecha de Pago', bold: true, size: 24, font: 'Calibri' }),
          new TextRun('\t'),
          new TextRun('\t'),
          new TextRun({ text: 'Método', bold: true, size: 24, font: 'Calibri' }),
          new TextRun('\t'),
          new TextRun({ text: 'Nota', bold: true, size: 24, font: 'Calibri' }),
        ],
        tabStops,
        spacing: { after: 100 },
      })
    );
    payments.forEach((p) => {
      children.push(
        new Paragraph({
          children: [
            new TextRun({ text: formatter.format(p.amount), size: 24, font: 'Calibri' }),
            new TextRun('\t'),
            new TextRun({
              text: moment(p.paymentDate).tz('America/Costa_Rica').format('DD/MM/YYYY'),
              size: 24,
              font: 'Calibri',
            }),
            new TextRun('\t'),
            new TextRun('\t'),
            new TextRun({ text: p.method, size: 24, font: 'Calibri' }),
            new TextRun('\t'),
            new TextRun({ text: p.note || '', size: 24, font: 'Calibri' }),
          ],
          tabStops,
        })
      );
    });
    children.push(new Paragraph({ text: '', spacing: { after: 300 } }));
    children.push(
      new Paragraph({
        children: [new TextRun({ text: 'RESUMEN DE CUENTA', bold: true, size: 36, font: 'Calibri' })],
        alignment: AlignmentType.CENTER,
        spacing: { after: 200 },
      })
    );
    children.push(
      new Paragraph({
        children: [
          new TextRun({ text: 'Total Pagado: ', bold: true, size: 24, font: 'Calibri' }),
          new TextRun({ text: formatter.format(totalPagos), size: 24, font: 'Calibri' }),
        ],
        alignment: AlignmentType.CENTER,
        spacing: { after: 100 },
      })
    );
    children.push(
      new Paragraph({
        children: [
          new TextRun({ text: 'Total Pendiente: ', bold: true, size: 24, font: 'Calibri' }),
          new TextRun({ text: formatter.format(totalPendiente), size: 24, font: 'Calibri' }),
        ],
        alignment: AlignmentType.CENTER,
      })
    );

    const doc = new Document({ sections: [{ children }] });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, `Detalle_Cuenta_${clientName}.docx`);
  };

  const getIvaAmount = (order) => {
    const base =
      (parseFloat(order.parcial) || parseFloat(order.total) || 0) +
      (parseFloat(order.transporte) || 0);
    return (base * 0.13).toFixed(2);
  };

  return (
    <div className="account-detail">
      <h1>Detalle de la Cuenta - {clientName}</h1>

      {/* Acciones generales */}
      <div className="actions">
        <button onClick={() => setShowAbonoModal(true)}>Registrar Abono</button>
        <button onClick={handlePrint}>Imprimir Resumen</button>
        <button onClick={handleDownload}>Descargar</button>
      </div>

      {/* Pedidos */}
      <h2 style={{ textAlign: 'center' }}>Pedidos</h2>
      <table>
        <thead>
          <tr>
            <th>Número de Pedido</th>
            <th>Fecha y Hora</th> {/* ✅ NUEVA COLUMNA (sin cambiar clases/estructura) */}
            <th>Total</th>
            <th>N FACT</th> {/* nueva columna ya existente */}
            <th>Método de Pago</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              {/* Número de pedido (OR / F2000) */}
              <td>
                <button
                  className="order-number-button"
                  onClick={() => openOrderModal(order)}
                >
                  {order.orderNumber}
                </button>
              </td>

              {/* ✅ Fecha y Hora: scheduledTime */}
              <td>
  {order.scheduledTime
    ? moment(order.scheduledTime)
        .tz('America/Costa_Rica')
        .format('DD/MM/YYYY h:mma')
    : 'N/A'}
</td>

              {/* Total (uso totalPayment si existe, si no total) */}
              <td>
                {formatter.format(
                  parseFloat(order.totalPayment) ||
                    parseFloat(order.total) ||
                    0
                )}
              </td>

              {/* N FACT: botón pequeño para añadir/editar número de factura */}
              <td className="fact-cell">
                {order.fact ? (
                  <button
                    type="button"
                    className="fact-edit-button"
                    onClick={() => openFactModal(order)}
                    title="Editar número de factura"
                  >
                    {order.fact}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="fact-add-button"
                    onClick={() => openFactModal(order)}
                  >
                    Añadir
                  </button>
                )}
              </td>

              {/* Método de pago */}
              <td>{order.formaPago}</td>

              {/* Acciones */}
              <td>
                <button
                  className="hide-button"
                  onClick={() => hideOrder(order.id)}
                >
                  Ocultar
                </button>
              </td>
            </tr>
          ))}

          {orders.length === 0 && (
            <tr>
              <td colSpan="6">No hay pedidos registrados</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* MODAL DETALLE (usa misma estructura/labels de ActiveOrders para impresión) */}
      {selectedOrder && (
        <div className="ao-modal-overlay">
          <div className="ao-modal">
            <div className="ao-modal-header">
              <h2>Detalle del Pedido</h2>
              <button className="close-button" onClick={closeOrderModal}>
                X
              </button>
            </div>

            <div className="print-format">
              {selectedOrder.orderNumber?.startsWith('OR-') ? (
                // === VISTA OR- (foto 2)
                <div className="orden-ventana">
                  <p>
                    <strong>Número:</strong> {selectedOrder.orderNumber}
                  </p>
                  <p>
                    <strong>Ejecutiv@:</strong> {selectedOrder.ejecutivo || 'N/A'}
                  </p>
                  <p>
                    <strong>Cliente:</strong> {selectedOrder.customer || 'N/A'}
                  </p>
                  <p>
                    <strong>Para:</strong> {selectedOrder.para || 'N/A'}
                  </p>
                  <p>
                    <strong>Monto base:</strong> ₡{selectedOrder.total || 0}
                  </p>
                  <p>
                    <strong>IVA:</strong> {selectedOrder.iva || 'No'}
                  </p>
                  <p>
                    <strong>Total:</strong> ₡{selectedOrder.totalPayment || 0}
                  </p>
                  <p>
                    <strong>Fecha y Hora:</strong>{' '}
                    {selectedOrder.scheduledTime
                      ? moment(selectedOrder.scheduledTime)
                          .tz('America/Costa_Rica')
                          .format('DD/MM/YYYY h:mma')
                      : 'N/A'}
                  </p>
                  <p>
                    <strong>Detalle:</strong>{' '}
                    {selectedOrder.detalleEntrega || selectedOrder.orderItems || 'N/A'}
                  </p>
                  <p>
                    <strong>Recibido por:</strong> {selectedOrder.recibidoPor || 'N/A'}
                  </p>
                  <p>
                    <strong>Forma de Pago:</strong> {selectedOrder.formaPago || 'N/A'}
                  </p>

                  <hr />
                  <p style={{ fontSize: '0.8rem', color: '#ccc', marginTop: '1rem' }}>
                    Para su factura electrónica, le rogamos enviar los siguientes datos: <br />
                    Nombre o Razón Social, Cédula física o jurídica, Email, teléfono, dirección exacta <br />
                    al correo: <strong>Floristeria2000@hotmail.com</strong>
                  </p>
                </div>
              ) : (
                // === VISTA F2000- (foto 3)
                <>
                  <div className="orden-entrega">
                    <h3>
                      ORDEN DE ENTREGA NÚMERO <span>{selectedOrder.orderNumber}</span>
                    </h3>
                    <div className="row">
                      <div className="edit-form-group">
                        <p>
                          <strong>Fuente:</strong> {selectedOrder.fuente || 'N/A'}
                        </p>
                      </div>
                      <div className="edit-form-group">
                        <p>
                          <strong>Ejecutiv@:</strong> {selectedOrder.ejecutivo || 'N/A'}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="edit-form-group">
                        <p>
                          <strong>Para:</strong> {selectedOrder.para || 'N/A'}
                        </p>
                      </div>
                      <div className="edit-form-group">
                        <p>
                          <strong>Teléfono:</strong> {selectedOrder.telefono || 'N/A'}
                        </p>
                      </div>
                    </div>
                    <p>
                      <strong>Entregar En:</strong> {selectedOrder.entregarEn || 'N/A'}
                    </p>
                    <p>
                      <strong>Detalle:</strong>{' '}
                      {selectedOrder.detalleEntrega || selectedOrder.orderItems || 'N/A'}
                    </p>
                    <p>
                      <strong>Tarjeta:</strong> {selectedOrder.tarjeta || 'No'}
                    </p>
                    <p>
                      <strong>Recibido por:</strong> {selectedOrder.recibidoPor || 'N/A'}
                    </p>
                  </div>

                  <hr />

                  <div className="orden-produccion">
                    <h3>
                      ORDEN DE PRODUCCIÓN NÚMERO <span>{selectedOrder.orderNumber}</span>
                    </h3>
                    <div className="row">
                      <div className="edit-form-group">
                        <p>
                          <strong>Fuente:</strong> {selectedOrder.fuente || 'N/A'}
                        </p>
                      </div>
                      <div className="edit-form-group">
                        <p>
                          <strong>Ejecutiv@:</strong> {selectedOrder.ejecutivo || 'N/A'}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="edit-form-group">
                        <p>
                          <strong>Para:</strong> {selectedOrder.para || 'N/A'}
                        </p>
                      </div>
                      <div className="edit-form-group">
                        <p>
                          <strong>Teléfono:</strong> {selectedOrder.telefono || 'N/A'}
                        </p>
                      </div>
                    </div>
                    <p>
                      <strong>Fecha y Hora:</strong>{' '}
                      {selectedOrder.scheduledTime
                        ? moment(selectedOrder.scheduledTime)
                            .tz('America/Costa_Rica')
                            .format('DD/MM/YYYY h:mma')
                        : 'N/A'}
                    </p>
                    <p>
                      <strong>Detalle:</strong>{' '}
                      {selectedOrder.detalleEntrega || selectedOrder.orderItems || 'N/A'}
                    </p>
                    <p>
                      <strong>Parcial:</strong> ₡{selectedOrder.total || 0}
                    </p>
                    <p>
                      <strong>Transporte:</strong> ₡{selectedOrder.transporte || 0}
                    </p>
                    <p>
                      <strong>IVA:</strong>{' '}
                      {selectedOrder.iva === 'Si' ? `₡${getIvaAmount(selectedOrder)}` : 'N/A'}
                    </p>
                    <p>
                      <strong>Total:</strong> ₡{selectedOrder.totalPayment || 0}
                    </p>
                    <p>
                      <strong>Forma de Pago:</strong> {selectedOrder.formaPago || 'N/A'}
                    </p>
                  </div>
                </>
              )}
            </div>

            {/* Botones igual que ActiveOrders: imprimir pantalla + ticket */}
            <div className="ao-modal-actions">
              <button className="print-button" onClick={handlePrint}>
                Imprimir
              </button>
              <button className="print-receipt-button" onClick={handlePrintReceipt}>
                Imprimir OR (Ticket 80 mm)
              </button>
              <button onClick={closeOrderModal}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {/* Pagos */}
      <h2 style={{ textAlign: 'center' }}>Pagos</h2>
      <table>
        <thead>
          <tr>
            <th>Monto</th>
            <th style={{ padding: '0 2rem' }}>Fecha de Pago</th>
            <th style={{ padding: '0 2rem' }}>Método</th>
            <th>Nota</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p) => (
            <tr key={p.id}>
              <td style={{ padding: '0 2rem' }}>{formatter.format(p.amount)}</td>
              <td style={{ padding: '0 2rem' }}>
                {moment(p.paymentDate).tz('America/Costa_Rica').format('DD/MM/YYYY')}
              </td>
              <td style={{ padding: '0 2rem' }}>{p.method}</td>
              <td>{p.note}</td>
              <td>
                <button className="hide-button" onClick={() => hidePayment(p.id)}>
                  Ocultar
                </button>
              </td>
            </tr>
          ))}
          {payments.length === 0 && (
            <tr>
              <td colSpan="5">No hay pagos registrados</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* RESUMEN */}
      <div className="account-summary" style={{ textAlign: 'center' }}>
        <h3>RESUMEN DE CUENTA</h3>
        <p style={{ margin: '0.5rem 0' }}>
          <strong>Total Pagado:</strong> {formatter.format(totalPagos)}
        </p>
        <p style={{ margin: '0.5rem 0' }}>
          <strong>Total Pendiente:</strong> {formatter.format(totalPendiente)}
        </p>
      </div>

      {/* MODAL ABONO */}
      {showAbonoModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Registrar Abono</h3>
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                try {
                  await api.post(`/api/accountsReceivable/payment`, {
                    clientId: Number(clientId),
                    ...abonoForm,
                    paymentDate: moment
                      .tz(abonoForm.paymentDate, 'America/Costa_Rica')
                      .startOf('day')
                      .toDate(),
                  });
                  alert('Abono registrado exitosamente');
                  setShowAbonoModal(false);
                  setAbonoForm({ amount: '', paymentDate: '', method: '', note: '' });
                  const res = await api.get(`/api/accountsReceivable/${clientId}`);
                  setAccountData(res.data);
                } catch (err) {
                  console.error(err);
                  alert('Error al registrar abono');
                }
              }}
            >
              <label>Monto:</label>
              <input
                type="number"
                step="0.01"
                value={abonoForm.amount}
                onChange={(e) =>
                  setAbonoForm({ ...abonoForm, amount: e.target.value })
                }
                required
              />

              <label>Fecha de Pago:</label>
              <input
                type="date"
                value={abonoForm.paymentDate}
                onChange={(e) =>
                  setAbonoForm({ ...abonoForm, paymentDate: e.target.value })
                }
                required
              />

              <label>Método:</label>
              <input
                type="text"
                value={abonoForm.method}
                onChange={(e) =>
                  setAbonoForm({ ...abonoForm, method: e.target.value })
                }
                required
              />

              <label>Nota:</label>
              <input
                type="text"
                value={abonoForm.note}
                onChange={(e) =>
                  setAbonoForm({ ...abonoForm, note: e.target.value })
                }
              />

              <div className="modal-buttons">
                <button type="submit">Guardar Abono</button>
                <button
                  type="button"
                  onClick={() => setShowAbonoModal(false)}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL NÚMERO DE FACTURA */}
      {showFactModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Asignar número de factura</h3>
            <form onSubmit={handleSaveFact}>
              <label>N° de factura (4–6 dígitos):</label>
              <input
                type="text"
                value={factForm.fact}
                onChange={handleFactInputChange}
                maxLength={6}
                required
              />
              <div className="modal-buttons">
                <button type="submit">Guardar</button>
                <button
                  type="button"
                  onClick={closeFactModal}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountDetail;
